<div class="cover-container d-flex w-100 h-100 mx-auto flex-column" style="background-image: url(assets/img/download-bg.jpg);background-size:cover ;">
    <div class="position-relative overflow-hidden h-100 outerPanelCutomBranding" style="background-color:#fff">
        <div class="backgroundColorChangeBoxStaticImage"></div>
        <div class="backgroundColorChangeBox" style="background-color: rgba(33, 150, 243, 0.21);"></div>
        <header class="mb-auto">
          <div style="position: relative;">
            <img src="assets/img/211228_Logo2_RGB.svg" class="float-md-start mb-0 blah logo">
            <p class="companyName"></p>
          </div>
        </header>

        <div class="cover-container d-flex w-100 h-100 mx-auto flex-column position-relative downloadPageContainerMain d-flex aligns-items-center justify-content-center">
          
          <main class="px-3">
              <div class="container">
                  <div class="row gutters justify-content-md-center">
                    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 otpContainer">
                        <!-- <img src="img/download.svg" class="downloadIcon"> -->
                        <div class="card text-center mt-3   bg-transparent">
                            <div class="card-body pt-5 pb-5   bg-transparent">
                                <div class="d-flex flex-column bd-highlight mb-3 align-self-center text-center pageNotFoundDownloadPage">
                                    <!-- <img src="assets/img/broken-link.png" width="70px" height="70px"> -->
                                    <!-- <i class="fa-solid fa-link-slash"></i> -->
                                    <h2>404</h2>
                                    <h6 class="text-center text-light fs-26 fw-normal">{{'page_you_are_looking_not_found' | translate}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </main>

          <app-footer></app-footer>
        </div>
    </div>
</div>